"use strict"

export function initInScope($scope) {
    $scope.find('.js-product-grid').on('product-grid.success', function () {
        $('.js-lang-link').each(function () {
            let url = new URL(window.location.protocol + window.location.hostname + $(this).attr('href'));
            $(this).attr('href', url.pathname + window.location.search);
        });
    });
}